import PropTypes from 'prop-types';

export const KTBSButtonColor = {
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  info: 'info',
  dark: 'dark',
  light: 'light',
  white: 'white',
};

export const KTBSButtonType = {
  default: 'default',
  light: 'light',
  outline: 'outline',
};

export const KTBSButtonSize = {
  default: '',
  small: 'sm',
  large: 'lg',
};

export const KTBSButtonFontWeight = {
  lighter: 'lighter',
  light: 'light',
  normal: 'normal',
  bold: 'bold',
  bolder: 'bolder',
  boldest: 'boldest',
};

KTBSButton.propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(Object.values(KTBSButtonType)),
  color: PropTypes.oneOf(Object.values(KTBSButtonColor)),
  hoverColor: PropTypes.oneOf(Object.values(KTBSButtonColor)),
  titleColor: PropTypes.oneOf(Object.values(KTBSButtonColor)),
  size: PropTypes.oneOf(Object.values(KTBSButtonSize)),
  fontWeight: PropTypes.oneOf(Object.values(KTBSButtonFontWeight)),
  title: PropTypes.string,
  isBlock: PropTypes.bool,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
  iconElement: PropTypes.element,
  iconOnly: PropTypes.bool,
  circle: PropTypes.bool,
  additionalClassName: PropTypes.string,
  borderRadius: PropTypes.number,
  buttonTitleColor: PropTypes.string,
  buttonTitleFontWeight: PropTypes.string,
  bgColor: PropTypes.string,
  justifyCenter: PropTypes.bool,
  buttonTitleFontSize: PropTypes.number,
  height: PropTypes.number,
  fillTitle: PropTypes.bool,
};

function KTBSButton({
  id,
  type = KTBSButtonType.default,
  color = KTBSButtonColor.primary,
  hoverColor,
  titleColor,
  size = KTBSButtonSize.default,
  fontWeight = KTBSButtonFontWeight.normal,
  title = '',
  isBlock = false,
  active = false,
  disabled = false,
  onPress,
  iconElement,
  iconOnly = false,
  circle = false,
  additionalClassName = '',
  borderRadius,
  buttonTitleColor = 'white',
  buttonTitleFontWeight,
  bgColor,
  justifyCenter = true,
  buttonTitleFontSize,
  height,
  fillTitle = false,
}) {
  let buttonColor = color;
  if (hoverColor || titleColor) {
    buttonColor = KTBSButtonColor.light;
  }
  // MARK: --- Functions ---
  function handlePress() {
    if (onPress) {
      onPress();
    }
  }

  return (
    <div
      id={id}
      className={`
          d-flex align-items-center ${justifyCenter ? 'justify-content-center' : ''} ${
        borderRadius ? '' : 'rounded-lg'
      }
          btn 
          py-3
          ${iconOnly ? 'btn-icon' : ''}
          ${circle ? 'btn-circle' : ''}
          ${
            type === KTBSButtonType.default
              ? `btn-${buttonColor}`
              : type === KTBSButtonType.light
              ? `btn-light-${buttonColor}`
              : type === KTBSButtonType.outline
              ? `btn-outline-${buttonColor}`
              : ''
          }
          btn-${size}
          ${hoverColor ? `btn-hover-${hoverColor}` : ''}
          ${titleColor ? `btn-text-${titleColor} btn-hover-text-${titleColor}` : ''}
          font-weight-${fontWeight}
          ${disabled ? 'disabled' : ''}
          ${additionalClassName}
      `}
      onClick={handlePress}
      style={{
        borderRadius: borderRadius ? borderRadius : '',
        backgroundColor: bgColor ? bgColor : '',
        border: 'none',
        height: height,
      }}
    >
      {iconElement && (
        <div className={`${!_.isEmpty(title) && !iconOnly ? 'mr-1' : ''}`}>{iconElement}</div>
      )}
      {!iconOnly && (
        <span
          className={fillTitle ? `flex-fill text-left` : ''}
          style={{
            fontWeight: buttonTitleFontWeight,
            color: buttonTitleColor,
            whiteSpace: 'nowrap',
            fontSize: buttonTitleFontSize ? buttonTitleFontSize : '',
          }}
        >
          {title}
        </span>
      )}
    </div>
  );
}

export default KTBSButton;
